var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayIcon = function SvgPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFE4E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#play_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 30.75C9.406 30.75 3.25 24.594 3.25 17S9.406 3.25 17 3.25 30.75 9.406 30.75 17 24.594 30.75 17 30.75Zm-1.895-18.68a.55.55 0 0 0-.855.457v8.946a.55.55 0 0 0 .855.456l6.709-4.471a.55.55 0 0 0 0-.916l-6.71-4.471h.001Z",
    fill: "#E2231B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "play_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h33v33H0z"
  })))));
};
export default SvgPlayIcon;